import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { CircularProgress } from "@material-ui/core";

import ListingLayout from "../../Components/UI/ListingLayout";

import { printBadge } from "../../Stores/Print/actions";
import { useStyles } from "./style";

const ReviewBadge = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { activeLocation } = useSelector(
    (state) => state.SlickCareProfilesReducer
  );
  const { isPritingBadge } = useSelector((state) => state.PrintReducer);

  const [pdfString, setPdfString] = useState("");

  let loading = isPritingBadge;

  const onSuccess = (blobPDF) => {
    let reader = new FileReader();
    reader.readAsDataURL(blobPDF);
    reader.onloadend = () => {
      let base64String = reader.result;
      setPdfString(base64String);
    };
  };

  useEffect(() => {
    dispatch(printBadge({}, onSuccess));
  }, []);

  return (
    <ListingLayout
      title="Review Score"
      item="ENQUIRIES"
      hideAdd={true}
      hasFilter={false}
      showLocationToggle={true}
    >
      <>
        {loading ? (
          <div className={classes.loaderWrap}>
            <CircularProgress size="40px" />
          </div>
        ) : (
          <embed src={`${pdfString}`} width={"100%"} height={800} />
        )}
      </>
    </ListingLayout>
  );
};

export default ReviewBadge;
